export default __webpack_public_path__ + "static/media/010-hockey equipment.5b2ce188.svg";